import { useEffect } from "react"

import { aplicarAnalytics } from "@/lib/consentimento"
import { useConsentimentoStore } from "@/stores/consentimentoStore"

import { CookieBanner } from "./CookieBanner"
import { CookiePreferencesDialog } from "./CookiePreferencesDialog"

/**
 * Ponto de montagem do consentimento de cookies: aplica o gating dos scripts
 * de terceiros (Google Analytics) e renderiza a barra + o modal de preferências.
 */
export function CookieConsent() {
  const analiticos = useConsentimentoStore((s) => s.analiticos)

  // Carrega/descarrega o GA conforme a categoria `analiticos` (na montagem e
  // a cada mudança de consentimento).
  useEffect(() => {
    aplicarAnalytics()
  }, [analiticos])

  return (
    <>
      <CookieBanner />
      <CookiePreferencesDialog />
    </>
  )
}
